/* eslint-disable import/first */
import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation, useNavigate } from '@reach/router';

import { Redux, Slices } from 'spwa-ui-library';
import {
  signInWithGoogle,
  signInWithApple,
  signInWithFacebook,
} from 'spwa-ui-library/esm/library/firebase';

import facebook from './images/facebook.svg';
import google from './images/google.svg';
import apple from './images/apple.svg';
import css from './index.module.scss';
import Footer from './Footer';
import { postSocialValidate } from 'spwa-ui-library/esm/redux/store/authSlice';
import classNames from 'classnames';

const { useDispatch, useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
const { getProfile } = Slices.profileSlice;
const { selectDefaultAddress, postAddressPickup, postAddress } = Slices.addressSlice;
const { getCart, sendCart } = Slices.cartSlice;
const { addCoupon } = Slices.offerSlice;

const SocialMedia = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const config = useSelector((state) => state.config);
  const profile = useSelector((state) => state.profile);
  const cart = useSelector((state) => state.cart);
  const address = useSelector(selectDefaultAddress);
  const isDesktop = useSelector(selectDesktop);

  const contrySpecificValidation = config?.data?.data?.contrySpecificValidation;
  const countryName = profile?.country;

  const isExist = contrySpecificValidation?.findIndex(({ country }) => country === countryName);

  if (!contrySpecificValidation || !contrySpecificValidation[isExist]?.enableSocialLogin) {
    return (
      <>
        {isDesktop ? (
          <Grid className={classNames(css.socialMediaContainer, css.stickToBottom)}>
            <Footer />
          </Grid>
        ) : (
          ''
        )}
      </>
    );
  }
  // TODO: To be updated as per Pizzahut v20 APIs later on
  const mergeCart = (cartPayload) => {
    const items = cart.data.items;
    const payload = {
      body: {
        addressSubType: address.addressSubType,
        addressId: address?.id || '',
        addressType: cart.data.orderType,
        cartId: cartPayload.cartId,
        couponCode: cart.data?.promo?.couponCode,
        curMenuId: cart.data.menuId,
        curMenuTemplateId: cart.data.menuTemplateId,
        items: items,
        lat: 25.235519409179688,
        lng: 55.277530670166016,
        menuUpdatedAt: cartPayload.cartUpdatedAt,
        menuVersion: 'v1',
        orderType: cart.data.orderType,
        reorder: false,
      },
      headers: { country: cart.data.country },
    };

    dispatch(sendCart(payload)).then((res) => {});
  };

  // TODO: To be updated as per Pizzahut v20 APIs later on
  const mergeAddress = () => {
    if (Object.entries(address).length) {
      if (address.addressSubType !== 'DELIVERY') {
        const addressPayload = {
          addressSubType: address.addressSubType,
          addressType: address.addressType,
          addressVia: 'DEFAULT',
          areaId: address.areaId,
          storeId: address.storeId,
        };
        dispatch(postAddressPickup(addressPayload)).then((resp) => {
          window.localStorage.setItem('_add', JSON.stringify(resp.payload.data.data));
        });
      } else if (address.addressSubType === 'DELIVERY') {
        const deliveryPayload = {
          addressSubType: address.addressSubType,
          addressType: address.addressType,
          addressVia: 'DEFAULT',
          bldgName: address.bldgName,
          description: address.description,
          flatNum: address.flatNum,
          howToReach: address.howToReach,
          lat: address.lat,
          lng: address.lng,
          tag: address.tag,
        };
        dispatch(postAddress(deliveryPayload));
      }
    }
  };

  const loginFunction = {
    apple: signInWithApple,
    facebook: signInWithFacebook,
    google: signInWithGoogle,
  };

  const handleSocialLogin = async (type) => {
    try {
      const data = await loginFunction[type]();

      console.log(`received - `, data);

      if (data?.isVerified) {
        const profileData = JSON.parse(window.localStorage.getItem('profileDraft'));
        profileData['email'] = data?.email;
        profileData['name'] = data?.name;
        profileData['emailVerified'] = 1;
        dispatch(
          postSocialValidate({
            email: data?.email,
            name: data?.name,
            medium: type.toUpperCase(),
            socialKey: data?.socialKey,
          })
        ).then((resp) => {
          const retUrl = '/home';
          if (resp?.payload) {
            dispatch(getProfile());
            const cartPayload = {
              cartId: resp.payload.data.data.cartId,
              cartUpdatedAt: resp.payload.data.data.updatedAt,
            };
            if (Object.entries(address).length) {
              mergeAddress();
            }
            if (cart.data.items.length) {
              mergeCart(cartPayload);
            } else if (resp?.payload?.data?.data?.profileStep !== 0) {
              dispatch(getCart(cartPayload)).then((resp) => {
                if (!resp?.error && resp?.payload?.data?.data?.cartId) {
                  const promoObj = resp?.payload?.data?.data?.promo;
                  if (Object.entries(promoObj).length) {
                    dispatch(addCoupon(promoObj));
                  }
                }
              });
            }
            if (resp?.payload?.data?.data?.profileStep === 0) {
              navigate(`/${intl.locale}/login`);
              navigate(`/${intl.locale}/create-profile`, {
                state: {
                  oldLocation: !resp?.payload?.data?.data?.phnVerified
                    ? JSON.parse(JSON.stringify(location))
                    : null,
                  mobile: '',
                },
                replace: true,
              });
            } else if (location.state.component === 'delivery') {
              navigate(`/${intl.locale}/delivery`, { replace: true });
            } else {
              if (isDesktop) {
                if (retUrl === '/checkout') {
                  navigate(`/${intl.locale}${retUrl}`, { replace: true });
                } else {
                  const windowLength = window.history.length;
                  if (windowLength < 3) {
                    navigate(`/${intl.locale}/home`, { replace: true });
                  } else {
                    navigate(`/${intl.locale}${retUrl}`, { replace: true });
                  }
                }
              } else {
                navigate(`/${intl.locale}${retUrl}`, { replace: true });
              }
            }
          }
        });
      }
    } catch (err) {
      console.trace(err);
    }
  };

  const renderingOneButton =
    contrySpecificValidation[isExist]?.enableGoogleLogin &&
    contrySpecificValidation[isExist]?.enableFacebookLogin
      ? false
      : true;
  var isIOS = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream;
  return (
    <Grid className={css.socialMediaContainer}>
      <Grid className={css.headerText}>
        <Typography>
          <FormattedMessage
            id="loginWithSocialMedia"
            defaultMessage="Login with Social Media Accounts"
          />
        </Typography>
      </Grid>
      <Grid className={css.mediaButtonContainer}>
        {contrySpecificValidation[isExist]?.enableGoogleLogin && (
          <Button
            className={classNames(css.button, { [css.fullWidth]: renderingOneButton })}
            onClick={() => {
              handleSocialLogin('google');
            }}
          >
            <img src={google} alt="" />
            <Typography className={css.typography}>
              <FormattedMessage id="google" defaultMessage="GOOGLE" />
            </Typography>
          </Button>
        )}
        {contrySpecificValidation[isExist]?.enableFacebookLogin && (
          <Button
            className={classNames(css.button, { [css.fullWidth]: renderingOneButton })}
            onClick={() => {
              handleSocialLogin('facebook');
            }}
          >
            <img src={facebook} alt="" />
            <Typography className={css.typography}>
              <FormattedMessage id="facebook" defaultMessage="Facebook" />
            </Typography>
          </Button>
        )}
      </Grid>
      {false && contrySpecificValidation[isExist]?.enableAppleLogin && isIOS && (
        <Grid>
          <Grid
            className={css.appleButtonContainer}
            onClick={() => {
              handleSocialLogin('apple');
            }}
          >
            <img src={apple} alt="" />
            <Typography className={css.typography}>
              <FormattedMessage id="signInWithApple" defaultMessage="Sign in with Apple" />
            </Typography>
          </Grid>
        </Grid>
      )}
      <Footer />
    </Grid>
  );
};

export default SocialMedia;
